/**
 * Contact Request Service
 * Create this file as: frontend/src/services/contactService.js
 */

import api from './api';

const contactService = {
  // Get all contact requests with filters
  getAllContactRequests: async (params = {}) => {
    try {
      const response = await api.get('/admin/contact-requests', { params });
      return response;
    } catch (error) {
      console.error('Error fetching contact requests:', error);
      throw error;
    }
  },

  // Get single contact request
  getContactRequest: async (id) => {
    try {
      const response = await api.get(`/admin/contact-requests/${id}`);
      return response;
    } catch (error) {
      console.error('Error fetching contact request:', error);
      throw error;
    }
  },

  // Update contact request
  updateContactRequest: async (id, data) => {
    try {
      const response = await api.put(`/admin/contact-requests/${id}`, data);
      return response;
    } catch (error) {
      console.error('Error updating contact request:', error);
      throw error;
    }
  },

  // Delete contact request
  deleteContactRequest: async (id) => {
    try {
      const response = await api.delete(`/admin/contact-requests/${id}`);
      return response;
    } catch (error) {
      console.error('Error deleting contact request:', error);
      throw error;
    }
  },

  // Get contact request statistics
  getContactStats: async () => {
    try {
      const response = await api.get('/admin/contact-requests/stats');
      return response;
    } catch (error) {
      console.error('Error fetching contact stats:', error);
      throw error;
    }
  },

  // Bulk update status
  bulkUpdateStatus: async (ids, status) => {
    try {
      const promises = ids.map(id => 
        api.put(`/admin/contact-requests/${id}`, { status })
      );
      await Promise.all(promises);
      return { success: true };
    } catch (error) {
      console.error('Error bulk updating:', error);
      throw error;
    }
  }
};

export default contactService;